import { Box, Card, CardContent, Grid, makeStyles } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { GetRealSizeViewerFormInitialValues, IRealSizeViewerFormFields } from "src/models";
import { RealSizeViewerService } from "src/services/realSizeViewer.service";
import RealSizeViewerForm from "./realsize-viewer-form.component";

export const useStyles = makeStyles({
    image: { 
        height: "calc(100vh - 160px)", 
        width: "calc(100vh)", 
        objectFit: "contain", 
        border: "1px solid black",
        marginBottom: "24px",
        marginRight: "4px"
    },
    scrollable: {
        maxHeight: "calc(100vh - 120px)",
        overflowY: "auto",
        overflowX: "hidden",
        paddingRight: "4px"
    }
})

const RealSizeViewerTool: React.FC = () => {

    const classes = useStyles();
    const [image, setImage] = useState<any>(null);

    useEffect(() => {
        generateImage(GetRealSizeViewerFormInitialValues())
    }, [])

    const generateImage = async (formFields: IRealSizeViewerFormFields) => {
        const res = await RealSizeViewerService.generateImage(formFields);
        setImage(res.data?.model);
    }

    return (
        <>
            <Card>
                <CardContent>
                    <Grid container>
                        <Grid item sm={12} md={9}>
                            <Box display="flex">
                                {image ? <img src={'data:image/png;base64,' + image} className={classes.image} alt="Result" /> : null}
                            </Box>
                        </Grid>

                        <Grid item sm={12} md={3} className={classes.scrollable}>
                            <RealSizeViewerForm generateImage={generateImage}/>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    )
}

export default RealSizeViewerTool;